import MismatchedSoundRecordingsAudit from "../MusicAssetAuditComponents/MismatchedSoundRecordingsAudit";

const MismatchedSoundRecordingsRoute = () => {
  return <MismatchedSoundRecordingsAudit />;
};

export default MismatchedSoundRecordingsRoute;
